import React from 'react';
import './DeleteModal.css';

interface DeleteModalProps {
    isOpen: boolean;
    taskTitle: string;
    isSharedTask?: boolean;
    sharedWithCount?: number;
    onConfirm: () => void;
    onCancel: () => void;
}

export const DeleteModal: React.FC<DeleteModalProps> = ({ isOpen, taskTitle, isSharedTask, sharedWithCount, onConfirm, onCancel }) => {
    if (!isOpen) return null;

    const isOwnerDeletingSharedTask = !isSharedTask && sharedWithCount && sharedWithCount > 0;

    return (
        <div className="modal-overlay" onClick={onCancel}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <h2>{isSharedTask ? 'Leave Task' : 'Delete Task'}</h2>
                <p>
                    {isSharedTask
                        ? `Are you sure you want to leave "${taskTitle}"? This will remove it from your account, but the task will remain for the owner.`
                        : isOwnerDeletingSharedTask
                        ? `Are you sure you want to delete "${taskTitle}"? This will also remove it from ${sharedWithCount} ${sharedWithCount === 1 ? 'user\'s' : 'users\''} account${sharedWithCount === 1 ? '' : 's'}.`
                        : `Are you sure you want to delete "${taskTitle}"?`}
                </p>
                <div className="modal-buttons">
                    <button className="modal-btn cancel-btn" onClick={onCancel}>Cancel</button>
                    <button className="modal-btn confirm-btn" onClick={onConfirm}>
                        {isSharedTask ? 'Leave' : 'Delete'}
                    </button>
                </div>
            </div>
        </div>
    );
}; 